import React from "react";
import { Modal, Input, Select, Form, Button, DatePicker } from "antd";
import { SaveOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { FormRules } from "../../../dist/functions/formRules";
import { SelectOptionFooterExtraButtonComponent } from "../../SelectOptionFooterExtraButtonComponent";

const { Option } = Select;
export const AssetInquiriesFormModalComponent = (props) => {
  const {
    form = null,
    isVisible,
    onClickSubmit,
    onClickCancel,
    isUpdate,
    assets,
    onClickShowMoreAsset,
    users,
    onClickShowMoreUser,
  } = props;

  const dateFormat = "YYYY-MM-DD hh:mm:ss";

  /**
   * Form Rules
   *
   */

  // const {
  //   REQUIRED_ASSET_CUSTOM_FIELD_NAME,
  //   REQUIRED_ASSET_CUSTOM_FIELD_LABEL,
  //   REQUIRED_ASSET_CUSTOM_FIELD_TYPE,
  // } = FormRules;

  return (
    <Modal
      title={isUpdate ? "Update AssetInquiries" : "Create Asset Inquiries"}
      visible={isVisible}
      onOk={onClickSubmit}
      onCancel={onClickCancel}
      footer={[
        <Button key="back" onClick={onClickCancel} icon={<ArrowLeftOutlined />}>
          Return
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={onClickSubmit}
          icon={<SaveOutlined />}
        >
          Submit
        </Button>,
      ]}
    >
      <Form form={form} name="asset_inquiries" layout="vertical">
        <Form.Item
          label="Assets"
          name="asset_id"
          fieldKey="asset_id"
          shouldUpdate={true}
        >
          <Select
            placeholder="Select Asset"
            virtual={true}
            dropdownRender={(menu) => (
              <SelectOptionFooterExtraButtonComponent
                key="show_more"
                menu={menu}
                onClickShowMoreList={onClickShowMoreAsset}
                isClickShowMoreDisabled={
                  assets.data.length < assets.total ? false : true
                }
              />
            )}
          >
            {assets.data.map((item) => (
              <Option
                id={item.asset_id}
                key={item.asset_id}
                value={item.asset_id}
              >
                {item.asset_code}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="User"
          name="user_id"
          fieldKey="user_id"
          shouldUpdate={true}
        >
          <Select
            placeholder="Select User"
            virtual={true}
            dropdownRender={(menu) => (
              <SelectOptionFooterExtraButtonComponent
                key="show_more"
                menu={menu}
                onClickShowMoreList={onClickShowMoreUser}
                isClickShowMoreDisabled={
                  users.data.length < users.total ? false : true
                }
              />
            )}
          >
            {users.data.map((item) => (
              <Option
                id={item.users_id}
                key={item.users_id}
                value={item.users_id}
              >
                {item.users_email}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="alternate_number" label="Alternate Number">
          <Input />
        </Form.Item>

        <Form.Item name="preferred_time_to_call" label="Preferred Time To Call">
          <Input />
        </Form.Item>
        <Form.Item name="inquiry_message" label="Inquiry Message">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
